export default __webpack_public_path__ + "static/media/icon-send-sp.6d33765d.svg";